import { APP_KEY_IDS } from "../../constants/constants";
import BaseNativeAppContainer from "../base-native-app-container/BaseNativeAppContainer"
import { Editor } from '@tinymce/tinymce-react';
import Styles from "./Notes.module.scss";
import Loader from "../loader/Loader";

const Notes = () => {
  return (
    <BaseNativeAppContainer
      appId={APP_KEY_IDS.NOTES}
      loadFromX={30}
      width={900}
      height={625}
      title={"Notes"}
      MainScreen={
        <>
          <div className={Styles.loader}>
            <Loader />
          </div>

          <div className={Styles.editor}>
            <Editor
              apiKey={process.env.REACT_APP_TEXT_EDITOR_API_KEY}
              initialValue="<p>You can add notes here and they won't be stored on my server.</p>"
              init={{
                width: 900,
                height: 600,
                menubar: true,
                resize: false,
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor wordcount',
                  'searchreplace visualblocks code ',
                  'insertdatetime media table paste code help '
                ],
                toolbar: 'undo redo | formatselect | ' +
                  'bold italic backcolor | alignleft aligncenter ' +
                  'alignright alignjustify | bullist numlist outdent indent | ' +
                  'removeformat | help',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; }'
              }} />
          </div>
        </>


      }

    />
  )
}

export default Notes
